import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export const H1 = styled.h1`
  color: white;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const ResponsiveH1 = styled(H1)`
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
  }
`;
